/* TSU Custom JS — reviews modal opened from the PDP reviews pill */
(function () {
  'use strict';

  var PAGE_SIZE = 4;

  /* ---------------------------------------------------------------------------
     The reviews themselves.
     sections/tsu-reviews.liquid renders every TSU Review metaobject entry into
     window.TSU_REVIEWS, in the order the section shows them, and publishes the
     headline score and count as window.TSU_REVIEW_STATS. No review lives in this
     file any more, so adding one in the admin is all it takes.

     Each entry: n name, i initials, r rating 1-5, d date, t text, v verified,
     plus vid / poster / portrait when that entry has a video.
     --------------------------------------------------------------------------- */
  var REVIEWS = window.TSU_REVIEWS || [];
  var STATS   = window.TSU_REVIEW_STATS || {};

  var shown = 0;

  function star(filled) {
    return '<svg viewBox="0 0 24 24" style="fill:' + (filled ? '#F59E0B' : '#E4E7EC') + '">' +
      '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
  }

  function starRow(n, cls) {
    var out = '<span class="' + cls + '">';
    for (var i = 1; i <= 5; i++) out += star(i <= n);
    return out + '</span>';
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/"/g, '&quot;');
  }

  function buildModal() {
    // the score is fixed in the TSU Review Summary metaobject; averaging the
    // entries is only a fallback for when the section did not publish one
    var avg = STATS.score;
    if (!avg) {
      avg = 0;
      for (var i = 0; i < REVIEWS.length; i++) avg += REVIEWS[i].r;
      avg = (avg / REVIEWS.length).toFixed(1);
    }
    var total = STATS.count || REVIEWS.length;

    var el = document.createElement('div');
    el.className = 'tsu-rv-modal';
    el.id = 'tsu-rv-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML =
      '<div class="tsu-rv-ov" data-rv-close></div>' +
      '<div class="tsu-rv-box">' +
        '<button type="button" class="tsu-rv-close" data-rv-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="tsu-rv-head">' +
          '<h3>Customer Reviews</h3>' +
          '<div class="tsu-rv-sum">' + starRow(5, 'tsu-rv-stars') +
            '<span class="tsu-rv-score">' + avg + '</span>' +
            '<span class="tsu-rv-count">based on ' + total + ' customer reviews</span>' +
          '</div>' +
        '</div>' +
        '<div class="tsu-rv-list" id="tsu-rv-list"></div>' +
        '<div class="tsu-rv-foot" id="tsu-rv-foot"></div>' +
      '</div>';
    document.body.appendChild(el);

    // closest() rather than the element itself: the close button holds an <svg>,
    // so a click lands on the svg (or its line) and never on the button.
    el.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-rv-close]')) close();
    });

    // only one review video plays at a time ('play' does not bubble, so capture)
    el.addEventListener('play', function (e) {
      var playing = e.target;
      var all = el.querySelectorAll('video');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== playing) { try { all[i].pause(); } catch (err) {} }
      }
    }, true);

    // load more on scroll as well as on the button
    var list = el.querySelector('#tsu-rv-list');
    list.addEventListener('scroll', function () {
      if (list.scrollTop + list.clientHeight >= list.scrollHeight - 40) render();
    });

    return el;
  }

  function render() {
    if (shown >= REVIEWS.length) return;
    var list = document.getElementById('tsu-rv-list');
    var html = '';
    var end = Math.min(shown + PAGE_SIZE, REVIEWS.length);
    for (var i = shown; i < end; i++) {
      var r = REVIEWS[i];
      html +=
        '<div class="tsu-rv-item">' +
          '<div class="tsu-rv-top">' +
            '<span class="tsu-rv-name">' + escapeHtml(r.n) +
            '</span>' +
            '<span class="tsu-rv-date">' + escapeHtml(r.d) + '</span>' +
          '</div>' +
          starRow(r.r, 'tsu-rv-rate') +
          (r.p ? '<div class="tsu-rv-prod" style="font-size:12px;color:#6E6E73;margin:2px 0 6px;">Product: ' + escapeHtml(r.p) + '</div>' : '') +
          '<p class="tsu-rv-txt">' + escapeHtml(r.t) + '</p>' +
          (r.vid ?
            '<div class="tsu-rv-media">' +
              '<video class="tsu-rv-vid"' + (r.portrait ? ' data-portrait="1"' : '') +
                ' src="' + escapeAttr(r.vid) + '"' +
                (r.poster ? ' poster="' + escapeAttr(r.poster) + '"' : '') +
                ' controls muted playsinline preload="metadata"' +
                ' controlsList="nodownload" disablePictureInPicture></video>' +
            '</div>'
          : '') +
        '</div>';
    }
    list.insertAdjacentHTML('beforeend', html);
    shown = end;

    var foot = document.getElementById('tsu-rv-foot');
    if (shown >= REVIEWS.length) {
      foot.innerHTML = '<p class="tsu-rv-done">That&rsquo;s all ' + REVIEWS.length + ' reviews.</p>';
    } else {
      foot.innerHTML = '<button type="button" class="tsu-rv-more">Load more reviews</button>';
      foot.querySelector('.tsu-rv-more').addEventListener('click', render);
    }
  }

  function open() {
    var el = document.getElementById('tsu-rv-modal') || buildModal();
    if (shown === 0) render();
    el.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var el = document.getElementById('tsu-rv-modal');
    if (!el) return;
    var vids = el.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) { try { vids[i].pause(); } catch (err) {} }
    el.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var pill = document.querySelector('.tsu-revpill');
    if (!pill || !REVIEWS.length) return;
    pill.setAttribute('role', 'button');
    pill.setAttribute('tabindex', '0');
    pill.addEventListener('click', open);
    pill.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* ---------------------------------------------------------------------------
   PDP availability: show "Call for Price" instead of "Out of Stock".
   Covers the first render and every variant switch (the section's own
   tsuUpdateVariant rewrites that span, so we wrap it rather than fight it).
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var LABEL = 'Call for Price';
  var COLOR = '#EF4444'; // change here if you want a different colour

  function applyCallForPrice() {
    var el = document.getElementById('tsu-stock-txt');
    if (!el) return;
    var txt = (el.textContent || '').trim().toLowerCase();
    if (txt.indexOf('out of stock') === -1) return;
    el.innerHTML = '<strong style="color:' + COLOR + ';">' + LABEL + '</strong>';
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyCallForPrice();

    // wrap the section's variant handler so the label survives a variant change
    if (typeof window.tsuUpdateVariant === 'function') {
      var original = window.tsuUpdateVariant;
      window.tsuUpdateVariant = function (sel) {
        original(sel);
        applyCallForPrice();
      };
    }
  });
})();

/* ---------------------------------------------------------------------------
   Shared product-card Add to Cart.

   Every product card across the store renders its button from
   snippets/tsu-card-atc.liquid, which outputs .tsu-card-atc with a data-vid.
   One delegated listener here serves all of them, so the sections carry no
   script of their own:

     tsu-collection-grid, tsu-search, tsu-featured-products,
     tsu-ymal, tsu-article-related-products

   window.tsuAddToCart (defined in sections/tsu-cart-drawer.liquid, which the
   layout renders on every page) does the add and opens the drawer. The fetch
   below is only a fallback for the case where the drawer is not present.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SELECTOR = '.tsu-card-atc';
  var RESET_MS = 1600;

  function addToCart(btn) {
    var vid = btn.getAttribute('data-vid');
    if (!vid || btn.disabled) return;

    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding&hellip;';

    function succeeded() {
      btn.innerHTML = '&#10003; Added';
      setTimeout(function () {
        btn.innerHTML = original;
        btn.disabled = false;
      }, RESET_MS);
    }

    function failed() {
      btn.innerHTML = original;
      btn.disabled = false;
      alert('Could not add this item to the cart. Please try again.');
    }

    if (typeof window.tsuAddToCart === 'function') {
      window.tsuAddToCart(vid, 1).then(succeeded).catch(failed);
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (typeof window.tsuOpenCart === 'function') { window.tsuOpenCart(); succeeded(); }
        else { window.location.href = '/cart'; }
      })
      .catch(failed);
  }

  // Delegated, so cards rendered after page load are covered too.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(SELECTOR);
    if (!btn) return;
    // cards wrap their image and text in a link — never follow it from the button
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();